/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Score_Show_DismissedInputs */

const en_ats_score_show_dismissed = /** @type {(inputs: Ats_Score_Show_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show dismissed tips`)
};

const de_ats_score_show_dismissed = /** @type {(inputs: Ats_Score_Show_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlossene Tipps anzeigen`)
};

const fr_ats_score_show_dismissed = /** @type {(inputs: Ats_Score_Show_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher les conseils ignorés`)
};

const es_ats_score_show_dismissed = /** @type {(inputs: Ats_Score_Show_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar consejos descartados`)
};

const it_ats_score_show_dismissed = /** @type {(inputs: Ats_Score_Show_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra suggerimenti ignorati`)
};

const nl_ats_score_show_dismissed = /** @type {(inputs: Ats_Score_Show_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesloten tips tonen`)
};

const pl_ats_score_show_dismissed = /** @type {(inputs: Ats_Score_Show_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż odrzucone wskazówki`)
};

const fi_ats_score_show_dismissed = /** @type {(inputs: Ats_Score_Show_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä ohitetut vinkit`)
};

const da_ats_score_show_dismissed = /** @type {(inputs: Ats_Score_Show_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis afviste tips`)
};

const sv_ats_score_show_dismissed = /** @type {(inputs: Ats_Score_Show_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa stängda tips`)
};

/**
* | output |
* | --- |
* | "Show dismissed tips" |
*
* @param {Ats_Score_Show_DismissedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_score_show_dismissed = /** @type {((inputs?: Ats_Score_Show_DismissedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Score_Show_DismissedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_score_show_dismissed(inputs)
	if (locale === "fr") return fr_ats_score_show_dismissed(inputs)
	if (locale === "es") return es_ats_score_show_dismissed(inputs)
	if (locale === "it") return it_ats_score_show_dismissed(inputs)
	if (locale === "nl") return nl_ats_score_show_dismissed(inputs)
	if (locale === "pl") return pl_ats_score_show_dismissed(inputs)
	if (locale === "fi") return fi_ats_score_show_dismissed(inputs)
	if (locale === "da") return da_ats_score_show_dismissed(inputs)
	if (locale === "sv") return sv_ats_score_show_dismissed(inputs)
	return en_ats_score_show_dismissed(inputs)
});